import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { hw_changeCurrentOrganization } from '../../../../../actions/hostelWorldActions'
import {
    selectCurrentOrganization,
    selectOrganizationList
} from '../../../../../selectors/hostelworldSelectors/hwCurrentOrganization'

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 200,
        color: 'white'
    }
})

class CurrentOrganization extends Component {
    handleChange = e => {
        if (this.props.value !== e.target.value) {
            this.props.onChangeOrganization(e.target.value)
        }
    }

    render() {
        const { organizationList, value, classes } = this.props

        return (
            <form className={classes.root}>
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="organization-simple">Выберите организацию</InputLabel>
                    <Select
                        value={value}
                        onChange={this.handleChange}
                        inputProps={{
                            name: 'organization',
                            id: 'organization-simple'
                        }}
                    >
                        {organizationList.map(org => (
                            <MenuItem key={org.ourId} value={org.ourId}>
                                {org.remoteName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </form>
        )
    }
}

CurrentOrganization.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    organizationList: PropTypes.array
}
CurrentOrganization.defaultProps = {
    value: ''
}

const mapStateToProps = state => ({
    value: selectCurrentOrganization(state),
    organizationList: selectOrganizationList(state)
})

const mapDispatchToProps = dispatch => ({
    onChangeOrganization: data => dispatch(hw_changeCurrentOrganization(data))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(CurrentOrganization))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/MappingTabs/CurrentOrganization/CurrentOrganization.js